import { IPromise } from 'angular';
import * as moment from 'moment';

import * as Common from '../Common/modules';
import * as Models from '../Models';
import { LogoutResponse } from '../Models/Auth';
import * as AuthService from './AuthService';
import * as Services from '../Services';

export interface IUserService {
  getCurrentUser: () => ng.IPromise<any>;
  isUserInRole: (roleName: string) => ng.IPromise<any>;
  login: (username: string, password: string) => ng.IPromise<any>;
  logout: () => ng.IPromise<any>;
}

export class UserService implements IUserService {
  public user: Models.UserModel.UserModel;
  public lastRefreshTime: Date;
  public requests: any[];
  public inflight: boolean;

  public static $inject = ["igs.identityService","$state", "$q", "AuthService","ApplicationStatusApiClient"];

  constructor(
    private identityService: Common.Identity.Igs.Common.IIdentityService,
    private $state: angular.ui.IStateService,
    private $q: angular.IQService,
    private authService: AuthService.AuthService,
    private applicationStatusApiClient: Services.ApplicationStatusApiClient.ApplicationStatusApiClient
  ) {
    this.inflight = false;
    this.requests = [];

    //check if app is offline
    this.applicationStatusApiClient.IsAppOnline().then(
      (status: Models.AppStatusResponse) => {
        if (status.isAppOnline === false) {
          this.$state.go("login")
        }
      }
    )

  }

  public getCurrentUser = (): ng.IPromise<any> => {

    var deferred = this.$q.defer();
    if (!this.user || this.shouldRefreshUser()) {
      if (!this.inflight) {
        this.inflight = true;
        var that = this;
        this.identityService.getCurrentUser().then((data: Models.UserModel.UserModel) => {
          if (data) {
            that.user = data;
            that.lastRefreshTime = new Date();
            that.inflight = false;
            that.requests.forEach((x) => {
              x.resolve(that.user);
            });
            deferred.resolve(that.user);
          } else {
            that.inflight = false;

            if (window.location.href.indexOf('docusignRedirect') === -1 ) {
              that.identityService.goToLoginPage();
            }
            that.requests.forEach((x) => x.reject());
            deferred.reject();
          }
        });
      } else {
        this.requests.push(deferred);
      }
    } else {
      deferred.resolve(this.user);
    }
    return deferred.promise;
  };

  public isUserInRole = (role: string): ng.IPromise<any> => {
    var deferred = this.$q.defer();
    this.getCurrentUser().then(() => {
      deferred.resolve(this.user.roles.some((e) => e.name === role));
      return deferred.promise;
    });
    return deferred.promise;
  };

  public login = (username: string, role: string): ng.IPromise<any> => {
    var deferred = this.$q.defer();
    this.identityService.login(username, role).then((data: any) => {
      if (data && data.isSuccessful) {
        this.user = data.user;
        this.lastRefreshTime = new Date();
        deferred.resolve(data);
      } else {
        this.identityService.goToLoginPage();
        deferred.reject();
      }
    });
    return deferred.promise;
  };

  public logout = (): IPromise<any> => {
    this.user = null;
    this.lastRefreshTime = null;
    this.inflight = false;
    this.requests = [];
    return this.authService.logout();
  };

  private shouldRefreshUser = (): boolean => {
    var fortyFiveMinutesAgo = moment(new Date()).subtract(45, "minutes");
    var shouldRefreshUser = moment(this.lastRefreshTime).isBefore(fortyFiveMinutesAgo);
    if (shouldRefreshUser) {
      this.inflight = false;
      this.requests = [];
    }

    return shouldRefreshUser;
  };
}
